<template>
    <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.4"
        stroke-linecap="round"
        stroke-linejoin="round"
        width="16"
        height="16"
    >
        <path d="M5 12h14M13 6l6 6-6 6"></path>
    </svg>
</template>
